import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import SwipeSelector from './SwipeSelector.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FilterSlider',
  props: {
    filters: null,
    displayProperty: null,
    emitIndex: { type: Boolean },
    value: null
  },
  emits: ["input", "change"],
  setup(__props: any, { emit }: { emit: ({(e: 'input', value: any): void, (e: 'change', value: any): void}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    filters: any[],
    displayProperty?: string,
    emitIndex?: boolean,
    value?: any
}



const selectedItem = ref(props.value || (props.filters.length > 0 ? props.filters[0] : null));

const handleFilterChange = (filter: any) => {
    emit('input', filter);
    emit('change', filter);
};

return { __sfc: true,props, emit, selectedItem, handleFilterChange, SwipeSelector }
}

})